export type BetaMetricVariant =
  | 'clicks'
  | 'conversions'
  | 'impressions'
  | 'spend'
  | 'reach'
  | 'results';

export const BETA_METRIC_VARIANT_STYLES: Record<BetaMetricVariant, string> = {
  clicks: 'bg-[#F59E0B]',
  conversions: 'bg-[#2563EB]',
  impressions: 'bg-[#059669]',
  spend: 'bg-[#EF4444]',
  reach: 'bg-[#7C3AED]',
  results: 'bg-[#DB2777]',
};
